import { render } from "./BarbershopRegisterView.vue?vue&type=template&id=7f8e210a&scoped=true"
import script from "./BarbershopRegisterView.vue?vue&type=script&lang=js"
export * from "./BarbershopRegisterView.vue?vue&type=script&lang=js"

import "./BarbershopRegisterView.vue?vue&type=style&index=0&id=7f8e210a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8e210a"]])

export default __exports__